import prop from "./prop";
export var findByType = function (items, _type) {
    return Array.isArray(items) && items.length && items.find(function (_a) {
        var type = _a.type;
        return type === _type;
    });
};
export var getValueByType = function (arr, type) {
    return prop(findByType(arr, type), "value");
};
